import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './auth/auth.interceptor';
import { contentTypeInterceptor } from './content-type.interceptor';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import { lucideIcons } from '@app/shared/lucide-icons';

export const appConfig: ApplicationConfig = {
  providers: [
    provideEnvironmentNgxMask(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor, contentTypeInterceptor])),
    provideRouter(routes, withRouterConfig({ onSameUrlNavigation: 'reload' })),
    { provide: LUCIDE_ICONS, multi: true, useFactory: () => new LucideIconProvider(lucideIcons) },
  ],
};
